import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { QueryComponent } from '@skooldio/skooldio-graphql-utils';

import Loading from '../../Components/Loading';

QueryComponent.defaultProps.defaultLoadingFn = (loadingOverlay) => (
  <Loading
    dimmer={loadingOverlay}
    loaderProps={!loadingOverlay ? { active: true, inline: 'centered' } : {}}
  />
);

QueryComponent.defaultProps.renderError = (error) => {
  console.error(error);
  return <div />;
};

QueryComponent.defaultProps.renderLoading = () => {
  return <div />;
};

export default QueryComponent;
